import { AxiosError } from 'axios';
import { appToast } from 'components/Basic/CustomToast';
import { bulkUpdate, update } from 'components/CustomMapSelect/api';
import { useMutation } from 'react-query';
import { errorResponseHandler } from 'store/api/AxiosError';

export function useUpdateCustomMap(uuid: string) {
	return useMutation({
		mutationKey: `update-custom-map-${uuid}`,
		mutationFn: (args: {id: number , payload: Partial<DesignCustomMap>}) => {
			return update(args.id, args.payload);
		},
		onError: (e: AxiosError)=>{
			const { message } = errorResponseHandler(e);
			appToast.error(message);
		}
	});
}

export function useBulkUpdateCustomMap(uuid: string) {
	return useMutation({
		mutationKey: `bulk-update-custom-map-${uuid}`,
		mutationFn:  (payload: Partial<DesignCustomMap>[]) =>bulkUpdate(payload),
		onError: (e: AxiosError)=>{
			const { message } = errorResponseHandler(e);
			appToast.error(message);
		},
		
	});
}